import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../../shared/shared.module";
import {EnterDataComponent} from "./components/enter-data/enter-data.component";
import {MetricsScreenComponent} from "./screen/metrics-screen.component";
import {MaterialModule} from "../../shared/material-module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/metrics.reducer";
import {EffectsModule} from "@ngrx/effects";
import {MetricsEffects} from "./core/metrics.effects";
import {EditDataComponent} from './components/edit-data/edit-data.component';
import { EditDataCombinedComponent } from './components/edit-data-combined/edit-data-combined.component';


@NgModule({
  declarations: [
    MetricsScreenComponent,
    EnterDataComponent,
    EditDataComponent,
    EditDataCombinedComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StoreModule.forFeature('ss-cord.metrics', reducer),
    EffectsModule.forFeature(
      [MetricsEffects]
    ),
  ]
})
export class MetricsModule {
}
